import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IRendererPropsExtender } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import type { ReactRendererSiteConfig } from './types'

const isBuilderComponentModelProp = ({ isBuilderComponentModel }: ReactRendererSiteConfig): IRendererPropsExtender => {
	return {
		async extendRendererProps() {
			return {
				isBuilderComponentModel
			}
		},
	}
}

export const IsBuilderComponentModelProp = withDependencies([named(SiteFeatureConfigSymbol, name)], isBuilderComponentModelProp)
